import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';

export default (token) => {
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }));

  const errorLink = onError(({ graphQLErrors }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations }) =>
        console.error(`Graphql erro ${message} ${locations}`)
      );
    }
  });

  const link = from([
    errorLink,
    new HttpLink({ uri: `${process.env.REACT_APP_BACKEND_BASE_URL}/graphql/` }),
  ]);

  return new ApolloClient({
    link: authLink.concat(link),
    cache: new InMemoryCache(),
  });
};
